import { isReplayConsentToggleOn, mayRecordMainSession } from '@bookkeeper/shared/replay-consent';

/**
 * May the landing's main PostHog instance record this visitor? The same rule as apps/frontend (the shared
 * predicate), with one difference of fact: the replay choice is given in the app's sign-up form and
 * privacy settings and is stored on app.bookeper.pl, which this origin cannot read. So with the toggle
 * on (`VITE_SIGNUP_REPLAY_CONSENT_TOGGLE`, same value as the app's `NEXT_PUBLIC_SIGNUP_REPLAY_CONSENT_TOGGLE`;
 * a separate Vercel project) the landing never starts the recorder after an analytics accept. With it
 * off, an accept records exactly as before.
 */
export function mayRecordLandingSession(consentStatus: string | undefined): boolean {
  return mayRecordMainSession({
    analyticsAccepted: consentStatus === 'accepted',
    toggleOn: isReplayConsentToggleOn(import.meta.env.VITE_SIGNUP_REPLAY_CONSENT_TOGGLE),
    replayGranted: false,
  });
}
